import controller from './uiStateChanger.controller'
import template from './uiStateChanger.template.html'

export default {
  restrict: 'E',
  transclude: true,
  bindings: {
    sender: '<',
    action: '<',
    stateName: '@',
    toggleStates: '<',
    toggleBetweenStates: '<',
    priority: '@',
    payload: '<',
    disableInputs: '<',
    i18nAssist: '@',
  },
  replace: true,
  template,
  controller,
  controllerAs: 'vm',
}
